<template>
	<div class="content-section-b" id="about-me">
		<div class="container ">
			<div class="row">
				<div class="col-lg-12">
					<h2 class="section-heading">About Me</h2>
					<p class="lead">
						I'm a CS Grad Student from Norwalk, CT. I have serious for UI
						effects, animations and creating intuitive, dynamic user
						experiences.
					</p>
					<p class="lead">
						I have experience in developing and maintaining websites using
						varieties of frameworks and web technologies like Vue.js, React,
						HTML5, CSS3, Vanilla JS, SCSS & SASS, and many more. Moreover, I
						have used different testing JavaScript frameworks likes Jest, Mocha,
						Chai, cypress to test and optimize the code. I’m familiar with
						different IDEs but VScode is my favorite also, GitHub and Bit-Bucket
						fulfills my need of version control in the various project by using
						CI/CD pipeline and testing together for better workflow.
					</p>

					<a target="_blank" href="https://www.linkedin.com/in/ritesh-parmar/"
						><button
							id="button"
							class="animated infinite pulse btn btn-success btn-lg mt-4 mx-5"
						>
							<i class="icon fab fa-linkedin-in" aria-hidden="true"></i> learn
							More
						</button></a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.content-section-b {
	padding: 50px 0;
	background: #65ce9b;
	text-align: center;
	color: white;
}

#button {
	color: white;
	font-size: 24px;
	margin-top: 30px;
	border: solid 6px white;
	background: linear-gradient(
		rgba(18%, 67%, 98%, 0.75),
		rgba(18%, 67%, 98%, 0.85)
	);
	padding: 15px;
	text-transform: uppercase;
	font-weight: 500;
}
</style>
